var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.validEndDate)?_c('div',{staticClass:"countdown"},_vm._l((_vm.timeRemaining),function(time,index){return _c('div',{key:index,staticClass:"countdown__text"},[_c('span',{staticClass:"countdown__number"},[_vm._v(_vm._s(time.value))]),_c('span',[_vm._v(" "+_vm._s(time.key)+" ")])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }